module.exports = __webpack_public_path__ + "img/ZainDisabeld.fb398bcd.svg";